<template>
  <div>
    <div class="wrapper">
      <!-- section dashboard -->
      <section id="dashboard-owner" class="section-duke section-dark jpadding jpadding-15 duke-style">
        <div class="jtitle jtitle-80 text-center">
          <h3><small>DUKE</small><br />OWNER</h3>
          <div class="jsubtitle">
            <p id="p-text">
              <small
                ><strong>Welcome {{ user.firstName + " " + user.lastName }} to DUKE OWNER CLUB.</strong
                ><br />Here you have access to all your watch-related information, you can manage your watch
                services, warranty and appointments, and have a priority access to the news and
                novelties.</small
              >
            </p>
          </div>
        </div>

        <div class="grid-3">
          <router-link
            :to="{ name: 'MyWatches' }"
            class="jcard-img"
            style="background-image: url('/assets/photos/ui/dashboard-buttons/my-watches.jpg')"
          >
            <div class="jcard-img-overlay"></div>
            <div class="jcard-img-content">
              <i class="fal fa-watch fa-3x mb-3"></i>
              <h5 class="m-0 p-0">My Watches</h5>
              <!-- <p class="m-0"><small>OWNERS CLUB</small></p> -->
            </div>
          </router-link>
          <router-link
            :to="{ name: 'Collection' }"
            class="jcard-img"
            style="background-image: url('/assets/photos/ui/dashboard-buttons/shop.jpg')"
          >
          <div class="jcard-img-overlay"></div>
            <div class="jcard-img-content">
            <i class="fal fa-shopping-cart fa-3x mb-3"></i>
            <h5 class="m-0 p-0">Shop</h5>
            <!-- <p class="m-0"><small>OWNERS CLUB</small></p> -->
          </div>
          </router-link>
          <router-link :to="{ name: 'PaymentsOwner' }" class="jcard-img"
            style="background-image: url('/assets/photos/ui/dashboard-buttons/payments.jpg')">
            <div class="jcard-img-overlay"></div>
            <div class="jcard-img-content">
            <i class="fal fa-credit-card fa-3x mb-3"></i>
            <h5 class="m-0 p-0">Payments</h5>
            <!-- <p class="m-0"><small>OWNERS CLUB</small></p> -->
          </div>
          </router-link>
          <router-link :to="{ name: 'AppointmentsList' }" class="jcard-img"
            style="background-image: url('/assets/photos/ui/dashboard-buttons/appointments.jpg')">
            <div class="jcard-img-overlay"></div>
            <div class="jcard-img-content">
            <i class="fal fa-clock fa-3x mb-3"></i>
            <h5 class="m-0 p-0">Appointments</h5>
            <!-- <p class="m-0"><small>OWNERS CLUB</small></p> -->
          </div>
          </router-link>
          <router-link :to="{ name: 'NewsOwner' }" class="jcard-img"
            style="background-image: url('/assets/photos/ui/dashboard-buttons/news.jpg')">
            <div class="jcard-img-overlay"></div>
            <div class="jcard-img-content">
            <i class="fal fa-newspaper fa-3x mb-3"></i>
            <h5 class="m-0 p-0">News</h5>
            <!-- <p class="m-0"><small>OWNERS CLUB</small></p> -->
          </div>
          </router-link>
          <router-link :to="{ name: 'Contact' }" class="jcard-img"
            style="background-image: url('/assets/photos/ui/dashboard-buttons/contact.jpg')">
            <div class="jcard-img-overlay"></div>
            <div class="jcard-img-content">
            <i class="fal fa-headset fa-3x mb-3"></i>
            <h5 class="m-0 p-0">Contact</h5>
            <!-- <p><i class="m-0 fal fa-link"></i></p> -->
          </div>
          </router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase/firebaseInit";
import C from "@/const";
const auth = firebase.auth;
const db = firebase.db;

export default {
  name: "DashboardOwner",
  data() {
    return {
      //userId: firebase.auth().currentUser.uid,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters.getUser;
      },
    },
  },
  beforeCreate() {
    //load user
    var userDocRef = db.collection(C.COLLECTION.USERS).doc(auth.currentUser.uid);
    userDocRef
      .get()
      .then((userDoc) => {
        this.$store.commit("setUser", userDoc.data());
      })
      .catch(function (error) {
        console.log("Error getting USER document:", error);
      });
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/css/platform.scss";
</style>
